import Vue from 'vue'
import VueLocalforage from 'v-localforage'

Vue.use(VueLocalforage, {"name":"getnext","storeName":"nuxtLocalForage","instances":[{"name":"getnext","storeName":"posts"}]})

export default (ctx, inject) => {
  inject('localForage', Vue.$localforage)
}
